import { SET_USER_PROFILE, SET_USER_APPROVAL, SET_USER_PICTURE } from '../actions/profile';

const initialState = {
  userProfile: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.userProfile,
      };
    case SET_USER_APPROVAL:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          ApproverKey: action.resp.ApproverKey,
        },
      };
    case SET_USER_PICTURE:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          ImageBytes: action.ImageBytes,
        },
      };
    default:
      return state;
  }
};
